import React, { useState, useEffect } from 'react'
// import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'
import './index.css'
import { connect } from 'react-redux'
import cloudIcon from '../../../../asset/cloudy.png'
import { weatherUpdate } from '../../../action/weather-action'
import { markerAction } from '../../../action/center-marker-action'
// import MarkerIcon from '../../../../asset/Waypoint_Dk_Green.png'

const Weather = (props) => {
  const [weatherCelsius, setWeatherCelsius] = useState(null)
  // const history = useHistory();

  const history = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const glatitude = urlParams.get('latitude');
  const glongitude = urlParams.get('longitude');
  let { weatherValue, mapReference, weatherUpdate, markerAction, userPreferences } = props;

  useEffect(() => {
    getLocation()
  }, [mapReference])

  useEffect(() => {
    if (weatherValue) {
      const tempFahrenheit = weatherValue.tempF;
      const tempCelsius = userPreferences.units === "imperial" ? tempFahrenheit : (tempFahrenheit - 32) / 1.8;
      setWeatherCelsius(tempCelsius)
    }
  }, [weatherValue])

  useEffect(() => {
    if (weatherValue) {
      const tempFahrenheit = weatherValue.tempF;
      const tempCelsius = userPreferences.units === "imperial" ? tempFahrenheit : (tempFahrenheit - 32) / 1.8;
      setWeatherCelsius(tempCelsius)
    }
  }, [userPreferences])

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          let coords = new google.maps.LatLng(latitude, longitude)
          if (props.mapReference && !glatitude && !glongitude) {
            // props.mapReference.setCenter(coords)
          }
          if (!props.markerCenter || props.markerCenter) {
            if (!props.markerCenter) {

            } else if (props.markerCenter && !props.markerCenter.mapObj) {

            }
          }
          weatherUpdate({ lat: latitude, lng: longitude })
        },
        (error) => {
          console.error('Error getting location:', error.message);
        }
      );
    } else {
      console.error('Geolocation is not supported by your browser');
    }
  };

  const getWeather = () => {
    let weather = mapReference && mapReference.getCenter()
    const latitude = weather.lat();
    const longitude = weather.lng();
    weatherUpdate({ lat: latitude, lng: longitude })
  }

  return (
    <>
      {weatherValue ?
        <div className={'weather-container'}>
          <div className={weatherCelsius ? 'weather-box-container' : 'weather-box-container-after-value'}>
            <div className={weatherCelsius ? 'clouds-continer' : 'clouds-continer-after-value'} onClick={() => { !weatherCelsius && getWeather() }}>
              <img className='cloud-icon' src={cloudIcon} ></img>
            </div>
            {weatherCelsius &&
              <div className='weather-value-container'>
                <p className='weather-content'>{` ${weatherCelsius && weatherCelsius.toFixed(0)}°${userPreferences.units === "imperial" ? 'F' : 'C'}`}</p>
              </div>}
          </div>
        </div>
        :
        ''}
    </>
  )
}

const mapStateToProps = state => ({
  weatherValue: state.weatherValue,
  mapReference: state.mapReference(),
  markerCenter: state.markerCenter,
  userPreferences: state.userPreferences,
})

const mapDispatchToProps = dispatch => ({
  weatherUpdate: (data) => dispatch(weatherUpdate(data)),
  markerAction: (payload) => dispatch(markerAction(payload))
})
export default connect(mapStateToProps, mapDispatchToProps)(Weather)